import api from './axios';

export const reportService = {
  // Get all reports (filters can be applied via query params)
  getAll: async (params) => {
    const response = await api.get('/reports/', { params });
    return response.data;
  },

  // Get single report by ID
  getById: async (id) => {
    const response = await api.get(`/reports/${id}/`);
    return response.data;
  },

  // Create new report (FormData for file upload support)
  create: async (data) => {
    const response = await api.post('/reports/', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Update report
  update: async (id, data) => {
    const response = await api.patch(`/reports/${id}/`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Delete report
  delete: async (id) => {
    await api.delete(`/reports/${id}/`);
  },

  // Head specific: Approve or Reject
  reviewHead: async (id, { action, comment }) => {
    // action: 'approve' | 'reject'
    const response = await api.post(`/reports/${id}/head_review/`, { action, comment });
    return response.data;
  },

  // Vice specific: Final approval
  reviewVice: async (id, { action, comment }) => {
    // action: 'approve' | 'reject'
    const response = await api.post(`/reports/${id}/vice_review/`, { action, comment });
    return response.data;
  },

  // Get Dashboard Stats
  getDashboardStats: async () => {
    const response = await api.get('/reports/dashboard_stats/');
    return response.data;
  }
};
